<template>

    <div style="text-align: center;margin-top: 180px">
    <div v-if="showTip" id="weixinTip" ref="weixin" >
        <p >
            在微信中无法下载APP
            <br />
            1. 请点击右上角按钮
            <br />
            2. 选择【在浏览器中打开】
        </p>
    </div>
    <!--<Imgs @clickit="viewImg" :imgSrc="imgSrc"></Imgs>-->
    <!--<div name="downloadfile" onclick="downloadExcel()" >APP下载</div>-->
        <div style="align-items: center ;z-index: 1">
        <a rel="noopenner noreferrer"  target="_blank"  :href=href>APP下载</a>
        </div>
    </div>
</template>

<script>
    //import Imgs from "../../components/img.vue"
    export default {
        name: "download",

        data() {
            return {
                showTip:false,
                href:window.origin+"/wyyd_1.0.apk"
            }
        },
        /*components: {
            Imgs
        },*/
        created() {
            const { userAgent } = navigator
            const isWeixin = !!/MicroMessenger/i.test(userAgent)
            this.isAndroid =
                userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1
            this.isMac = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
            if (isWeixin) {
                //如果是微信环境，就弹出遮罩层
                this.showTip = true
                //alert(11)
            }
           /* const ua = navigator.userAgent.toLowerCase();
            const isWeixin = ua.indexOf('micromessenger') !== -1;
            const isInApp = /(^|;\s)app\//.test(ua);
            if (isWeixin) {
                if (window.__wxjs_environment === 'miniprogram') {
                    return 'wxapp';
                } else {
                    return 'wxh5';
                }
            } else {
                if (!isInApp) {
                    return 'browser';
                } else {
                    return 'app';
                }
            }*/
        },
        methods: {
           /* viewImg() {
                this.imgSrc = "";
            },

            clickImg() {
// 获取当前图片地址 (我在组件的地址是写死的，你们可以改为动态的)
                this.imgSrc = "../assets/image/img_2.png";
            },*/

            downloadExcel() {
                let a = document.createElement('a')
                a.href = window.origin+"/wyyd_1.0.apk"
                a.click();
            },
            isApp(){

            }
        }
    }



</script>

<style scoped>
    .wxtip {
        background: rgba(0, 0, 0, 0.8);
        text-align: center;
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 100;
        display: none;

      /*img {
        width: 100%;
      }*/
    }

    .wxtip-txt {
        margin-top: 107px;
        color: #fff;
        font-size: 20px;
        line-height: 1.8;
    }
</style>
